//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Diagonosis = createAsyncThunk(
  "Diagonosis",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingDiagonosis(""));
      const response = await UsePortalApi(
        `Patient/Condition`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingDiagonosisSuccess(response[0].entry)) : dispatch(gettingDiagonosisFailed())

      } else {
        dispatch(
          gettingDiagonosisFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingDiagonosisFailed(error));
    }
  }
);
const DiagonosisSlice = createSlice({
  name: "Diagonosis",
  initialState: {
    DiagonosisData: null,
    isDiagonosisLoading: false,
    isDiagonosisError: false,
  },
  reducers: {
    gettingDiagonosis: (state, action) => {
      state.DiagonosisData = null;
      state.isDiagonosisLoading = true;
      state.isDiagonosisError = false;
    },
    gettingDiagonosisSuccess: (state, action) => {
      state.DiagonosisData = action.payload;
      state.isDiagonosisLoading = false;
      state.isDiagonosisError = false;
    },
    gettingDiagonosisFailed: (state, action) => {
      state.DiagonosisData = null;
      state.isDiagonosisLoading = false;
      state.isDiagonosisError = true;
    },
    gettingDiagonosisClear: (state, action) => {
      state.DiagonosisData = null;
      state.isDiagonosisLoading = false;
      state.isDiagonosisError = false;
    },
  },
});
export const {
  gettingDiagonosis,
  gettingDiagonosisSuccess,
  gettingDiagonosisFailed,
  gettingDiagonosisClear,
} = DiagonosisSlice.actions;
export default DiagonosisSlice.reducer;
